import { pxToRem } from '../../../../utils';
export default (function (siteVars) {
  return {
    borderRadius: siteVars.borderRadius,
    borderColor: siteVars.colorScheme["default"].border,
    borderColorPrimary: siteVars.colors.brand[500],
    borderColorDisabled: siteVars.colorScheme.brand.foregroundDisabled,
    smallDimension: pxToRem(24),
    smallPadding: "0 ".concat(pxToRem(8)),
    smallMinWidth: '0',
    smallBoxShadow: 'none',
    padding: "0 ".concat(pxToRem(16))
  };
});